import {
  FETCH_MOBILE_DEVICES_APPLICATION_REPORT,
  FETCH_MOBILE_DEVICES_APPLICATION_REPORT_ERROR,
  SET_MOBILE_DEVICES_APPLICATION_REPORT,
  FETCH_MOBILE_DEVICES_REPORT,
  FETCH_MOBILE_DEVICES_REPORT_ERROR,
  SET_FETCH_MOBILE_DEVICES_REPORT,
  FETCH_MOBILE_DEVICES_NETWORK_REPORT,
  FETCH_MOBILE_DEVICES_NETWORK_REPORT_ERROR,
  SET_MOBILE_DEVICES_NETWORK_REPORT,
  FETCH_MOBILE_DEVICES_SUMMARYCARD,
  FETCH_MOBILE_DEVICES_SUMMARYCARD_ERROR,
  SET_MOBILE_DEVICES_SUMMARYCARD,
  DOWNLOAD_MOBILE_DEVICES_INSIGHTS,
  DOWNLOAD_MOBILE_DEVICES_INSIGHTS_SUCCESS,
  DOWNLOAD_MOBILE_DEVICES_INSIGHTS_FAILURE,
} from '../constants';


const initialState = {
  mobileDevicesApplicationDataLoaded: false,
  mobileDevicesApplicationData: [],
  mobileDevicesReportDataLoaded: false,
  mobileDevicesReportData: [],
  mobileDevicesNetworkDataLoaded: false,
  mobileDevicesNetworkData: [],
  mobileDevicesSummaryDataLoaded: false,
  mobileDevicesSummaryData: {},
  downloadingCSV: false,
  csvType: null,
}


const mobileDevices = (state = initialState, action) => {

  switch (action.type) {

    case FETCH_MOBILE_DEVICES_APPLICATION_REPORT:
      return {
        ...state,
        mobileDevicesApplicationDataLoaded: false,
      };
    case FETCH_MOBILE_DEVICES_APPLICATION_REPORT_ERROR:
      return {
        ...state,
      };
    case SET_MOBILE_DEVICES_APPLICATION_REPORT:
      return {
        ...state,
        mobileDevicesApplicationDataLoaded: true,
        mobileDevicesApplicationData: action.data,
      };
    case FETCH_MOBILE_DEVICES_REPORT:
      return {
        ...state,
        mobileDevicesReportDataLoaded: false,
      };
    case FETCH_MOBILE_DEVICES_REPORT_ERROR:
      return {
        ...state,
      };
    case SET_FETCH_MOBILE_DEVICES_REPORT:
      return {
        ...state,
        mobileDevicesReportDataLoaded: true,
        mobileDevicesReportData: action.data,
      };
    case FETCH_MOBILE_DEVICES_NETWORK_REPORT:
      return {
        ...state,
        mobileDevicesNetworkDataLoaded: false,
      };
    case FETCH_MOBILE_DEVICES_NETWORK_REPORT_ERROR:
      return {
        ...state,
      };
    case SET_MOBILE_DEVICES_NETWORK_REPORT:
      return {
        ...state,
        mobileDevicesNetworkDataLoaded: true,
        mobileDevicesNetworkData: action.data,
      };
    case FETCH_MOBILE_DEVICES_SUMMARYCARD:
      return {
        ...state,
        mobileDevicesSummaryDataLoaded: false,
      };
    case FETCH_MOBILE_DEVICES_SUMMARYCARD_ERROR:
      return {
        ...state,
      };
    case SET_MOBILE_DEVICES_SUMMARYCARD:
      return {
        ...state,
        mobileDevicesSummaryDataLoaded: true,
        mobileDevicesSummaryData: action.data,
      };
    case DOWNLOAD_MOBILE_DEVICES_INSIGHTS:
      return {
        ...state,
        downloadingCSV: true,
        csvType: action.csvType,
      };
    case DOWNLOAD_MOBILE_DEVICES_INSIGHTS_SUCCESS:
      return {
        ...state,
        downloadingCSV: false,
      };
    case DOWNLOAD_MOBILE_DEVICES_INSIGHTS_FAILURE:
      return {
        ...state,
        downloadingCSV: false,
      };
    default:
      return state;
  }
}

export default mobileDevices;
